import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A rack of electrical conduit: lengths of grey and galvanised tube banded into
// a bundle on two timber bearers, the way runs are staged before being pulled.
// A site stores prop.
const BEARER = "#6e4f2e";
const TUBE_A = "#9aa0a6";
const TUBE_B = "#7c8288";
const TUBE_C = "#b87333";
const BAND = "#3a3a3e";

export const conduitBundle = defineModel({
  id: "conduit-bundle",
  batchId: "electric",
  name: "Conduit bundle",
  tags: ["prop", "electric", "power", "cable", "conduit", "yard"],
  summary: "Banded lengths of conduit on timber bearers.",
  footprint: 0.5,
  parts(): Part[] {
    const parts: Part[] = [
      // Two timber bearers.
      { geometry: new THREE.BoxGeometry(0.12, 0.08, 0.5), color: BEARER, position: [-0.38, 0.04, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.08, 0.5), color: BEARER, position: [0.38, 0.04, 0] },
    ];
    // A pyramid stack of tubes along X.
    const rows: [number, number, string][] = [
      [0.14, -0.18, TUBE_A], [0.14, -0.06, TUBE_B], [0.14, 0.06, TUBE_A], [0.14, 0.18, TUBE_C],
      [0.225, -0.12, TUBE_B], [0.225, 0.0, TUBE_C], [0.225, 0.12, TUBE_A],
      [0.3, -0.06, TUBE_A], [0.3, 0.06, TUBE_B],
    ];
    for (const [y, z, c] of rows) {
      parts.push({ geometry: new THREE.CylinderGeometry(0.055, 0.055, 0.94, 12), color: c, position: [0, y, z], rotation: [0, 0, Math.PI / 2] });
    }
    // Banding straps near each end.
    for (const x of [-0.34, 0.34]) {
      parts.push({ geometry: new THREE.TorusGeometry(0.12, 0.012, 4, 14), color: BAND, position: [x, 0.22, 0], rotation: [0, Math.PI / 2, 0], scale: [1, 1.4, 1] });
    }
    return parts;
  },
  animations: [],
});
